<template>
  <div class="findlaw_alsz">
    <div class="alszhfls_fluid w_100">
      <div class="alszhfls text_center">
        <div>
          <sec-title Text="按问题找合肥律师" desc-text="精准定位 快速解决" />
        </div>
        <div class="contt between wrap">
          <div
            v-for="(item, index) in 10"
            :key="item"
            class="ct_item"
            :class="{ mb30: index < 5 }"
          >
            <qestlaywin :imgStyle="{ width: '225px', height: '300px' }" />
          </div>
        </div>
      </div>
    </div>
    <div class="alszhfls2">
      <div class="as between">
        <div class="as_m">
          <div class="as_t flex_start">
            <img src="~assets/findlawyers/rm.png" />
            热门问题
          </div>
          <div class="as_c flex_start wrap">
            <span v-for="item in 14" :key="item">婚姻家庭</span>
          </div>
        </div>
        <div class="as_m">
          <div class="as_t flex_start">
            <img src="~assets/findlawyers/qt.png" />
            热门问题
          </div>
          <div class="as_c flex_start wrap">
            <span v-for="item in 14" :key="item">婚姻家庭</span>
          </div>
        </div>
      </div>
      <div class="as_b">
        <div class="as_t"><sub-title text="最新服务评价" /></div>
        <div class="between">
          <div class="as_b_item" v-for="item in 4" :key="item">
            <div class="ad flex_start cor333">
              <div>安徽-合肥</div>
              <div>188****021</div>
              <div class="cor9999">8小时前评价了：</div>
            </div>
            <div class="userin flex_start">
              <div>
                <img src="~assets/base/small_rentou.png" alt="" />
              </div>
              <div class="un_r">
                <div class="cor333 FontSize14">XXX律师</div>
                <div class="cor9999">XXX律师</div>
              </div>
            </div>
            <div class="cont cor9999">
              {{ "“感谢热心律师的回复！”" | toEllipsisFilter(30) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import subTitle from "views/home/components/subTitle";
import viewMore from "views/home/components/viewMore";
import qestlaywin from "../components/qestlaywin";
export default {
  components: {
    secTitle,
    viewMore,
    qestlaywin,
    subTitle,
  },
  data: () => ({}),
  methods: {},
};
</script>

<style lang="scss" scope>
.findlaw_alsz {
  .alszhfls_fluid {
    background-color: #f8f8f8;
    .alszhfls {
      width: 1200px;
      padding: 50px 0;
      margin: 0 auto;
      .contt {
        .ct_item {
          width: 225px;
          height: 385px;
        }
        .mb30 {
          margin-bottom: 30px;
        }
      }
    }
  }
  .alszhfls2 {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    .as {
      .as_m {
        width: 580px;
        height: 180px;
        padding: 26px 35px;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        .as_t {
          font-size: 24px;
          color: #333;
          margin-bottom: 10px;
          img {
            width: 26px;
            height: 26px;
            margin-right: 10px;
          }
        }
        .as_c {
          font-size: 16px;
          color: #888;
          span {
            margin-right: 21px;
            margin-top: 8px;
          }
        }
      }
    }
    .as_b {
      .as_t {
        margin: 30px 0;
      }

      .as_b_item {
        width: 280px;
        height: 160px;
        border: 1px solid #eeeeee;
        padding: 19px 20px;
        font-size: 12px;
        .cor9999 {
          color: #999;
        }
        .cor333 {
          color: #333;
        }
        .ad {
          div {
            margin-right: 6px;
          }
        }
        .userin {
          margin-top: 18px;
          .un_r {
            align-self: start;
          }
          img {
            margin-right: 10px;
            width: 40px;
            height: 40px;
          }
        }

        .cont {
          margin-top: 14px;
        }
      }
    }
  }
}
</style>